/**
 * Validates if a string is a valid HTTPS link
 */
export const isValidLink = (link: string): boolean => {
  const regex = /^(https?:\/\/)/i
  return regex.test(link)
}

/**
 * Validates if a string is a valid colour (hex or rgba)
 */
export const isValidColor = (color: string): boolean => {
  const hexColor = /^#([0-9A-F]{3}|[0-9A-F]{6})$/i
  const rgbaColor = /^rgba?\(\s*(\d{1,3}\s*,\s*){2}\d{1,3}\s*(,\s*[\d.]+\s*)?\)$/
  return hexColor.test(color) || rgbaColor.test(color)
}

/**
 * Moves a category after another in the list
 */
export const moveCategoryAfter = (list: string[], category: string, after: string): void => {
  const currentIndex = list.indexOf(category)
  const afterIndex = list.indexOf(after)
  if (currentIndex !== -1) list.splice(currentIndex, 1)
  if (afterIndex !== -1) list.splice(afterIndex + 1, 0, category)
  else list.push(category)
}

/**
 * Moves "Misc" category to the end of the list (before module categories)
 */
export const moveMiscToEnd = (categories: string[], moduleCategories: string[] = []): void => {
  const miscIndex = categories.indexOf('Misc')
  if (miscIndex !== -1) {
    const [misc] = categories.splice(miscIndex, 1)
    // Insert before module categories if they exist
    const firstModuleIndex = categories.findIndex((c) => moduleCategories.includes(c))
    if (firstModuleIndex !== -1) {
      categories.splice(firstModuleIndex, 0, misc)
    } else {
      categories.push(misc)
    }
  }
}

/**
 * Orders categories in a specific way for the layout settings.
 * Module categories are placed at the end, after Misc.
 */
export const orderCategories = (
  categories: string[],
  moduleCategories: string[] = []
): string[] => {
  const orderedCategories = [...categories]

  // Separate standard and module categories
  const standardCats = orderedCategories.filter((c) => !moduleCategories.includes(c))
  const moduleCats = orderedCategories.filter((c) => moduleCategories.includes(c))

  // Order standard categories
  moveCategoryAfter(standardCats, 'Main Page Texts', 'Main Page Appearance')
  moveCategoryAfter(standardCats, 'Result PDF', 'Result Page')
  moveMiscToEnd(standardCats, [])

  // Combine: standard categories first, then module categories
  return [...standardCats, ...moduleCats]
}
